//服务收费筛选表单
<template>
  <span>
    <el-form-item label="申请单号">
      <el-input v-model="params.orderCode" clearable placeholder="请输入" />
    </el-form-item>
    <el-form-item label="U8单号">
      <el-input v-model="params.u8SellCode" clearable placeholder="请输入" />
    </el-form-item>
    <el-form-item label="订单日期">
      <el-date-picker v-model="params.orderTime" type="daterange" range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" unlink-panels></el-date-picker>
    </el-form-item>
    <el-form-item label="客户名称">
      <el-input v-model="params.clientName" clearable placeholder="请输入" />
    </el-form-item>
    <el-form-item label="联系人">
      <el-input v-model="params.linkman" clearable placeholder="请输入" />
    </el-form-item>
    <el-form-item label="联系人手机">
      <el-input v-model="params.linkmanPhone" clearable placeholder="请输入" />
    </el-form-item>
    <el-form-item label="联系人地址">
      <el-input v-model="params.linkmanAddress" clearable placeholder="请输入" />
    </el-form-item>
    <el-form-item label="整机料号">
      <el-input v-model="params.deviceCode" clearable placeholder="请输入" />
    </el-form-item>
    <el-form-item label="整机名称">
      <el-input v-model="params.deviceName" clearable placeholder="请输入" />
    </el-form-item>
    <el-form-item label="整机SN">
      <el-input v-model="params.deviceSn" clearable placeholder="请输入" />
    </el-form-item>
    <el-form-item label="配件料号">
      <el-input v-model="params.code" clearable placeholder="请输入" />
    </el-form-item>
    <el-form-item label="配件名称">
      <el-input v-model="params.name" clearable placeholder="请输入" />
    </el-form-item>
    <el-form-item label="总价">
      <el-input v-model="params.totalAmount" clearable placeholder="请输入" />
    </el-form-item>
    <el-form-item label="工厂维修">
      <el-select v-model="params.send" clearable placeholder="请选择">
        <el-option label="是" :value="1" />
        <el-option label="否" :value="0" />
      </el-select>
    </el-form-item>
	<el-form-item label="物流信息">
	  <el-input v-model="params.logistics" clearable placeholder="请输入" />
	</el-form-item>
    <el-form-item label="工厂寄送配件">
      <el-select v-model="params.accessories" clearable placeholder="请选择">
        <el-option label="是" :value="1" />
        <el-option label="否" :value="0" />
      </el-select>
    </el-form-item>
    <el-form-item label="确认维修">
      <el-select v-model="params.repair" clearable placeholder="请选择">
        <el-option label="是" :value="1" />
        <el-option label="否" :value="0" />
      </el-select>
    </el-form-item>
    <el-form-item label="审核状态">
      <el-select v-model="params.auditStatus" clearable placeholder="请选择">
        <el-option v-for="item in $constant.auditStatus" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
    </el-form-item>
  </span>
</template>

<script>
import formTypeMixins from './formTypeMixins.js'
export default {
  mixins: [formTypeMixins]
}
</script>
